import type { ModuleNav } from '@saas/ui';

export const CALENDAR_READ = ['calendar.event.read.own', 'calendar.event.read.team', 'calendar.event.read.all'];
export const CALENDAR_WRITE = ['calendar.event.write', 'calendar.event.manage'];

/** calendar のメニュー。管理は会議室と外部カレンダーの取り込み元 */
export const calendarNav: ModuleNav = {
  module: 'calendar',
  items: [
    { label: 'カレンダー', to: '/calendar', icon: 'event', end: true, permission: CALENDAR_READ, description: '月表示・自分 / 部署 / 会議室' },
    { label: '予定を作る', to: '/calendar/events/new', icon: 'add', permission: CALENDAR_WRITE, description: '参加者・会議室・繰り返し' },
    { label: 'カレンダーの連携', to: '/calendar/connections', icon: 'swap_horiz', permission: CALENDAR_READ, description: '自分の Google / Microsoft と読み書きする' },
    { label: '自分の就業時間', to: '/calendar/working-hours', icon: 'schedule', permission: [...CALENDAR_READ, ...CALENDAR_WRITE], description: '空きの表示と日程調整リンクの候補に使う' },
  ],
  admin: [
    { label: '会議室', to: '/calendar/rooms', icon: 'home', permission: ['calendar.room.manage'], description: '会議室の登録・利用停止' },
    { label: '外部カレンダーの取り込み', to: '/calendar/external-sources', icon: 'swap_horiz', permission: ['calendar.external.manage'], description: 'Google / Microsoft の ICS URL' },
  ],
};
